import BasePlugin from './base-plugin'
import { setIcon, vjs_find } from './utils'

class ControlBarPlugin extends BasePlugin {
  constructor(player, options) {
    super(player)

    this.controlBarEl = vjs_find(this.playerElement, '.vjs-control-bar')
    this.pipControlEl = vjs_find(this.playerElement, '.vjs-picture-in-picture-control')
    let pipToggleEl = this.player.controlBar.el().lastChild
    if ((document.pictureInPictureEnabled && options.pipButton) || this.pipControlEl) {
      pipToggleEl = player.controlBar.getChild('pictureInPictureToggle').el()
    }

    this.pipToggleEl = pipToggleEl
    this.player.on('play', () => {
      if (options.pipButton !== true && this.pipControlEl) {
        this.pipControlEl.parentNode.removeChild(this.pipControlEl)
        this.pipControlEl = null
      }
    })
    this.player.$('.vjs-tech').addEventListener('enterpictureinpicture', () => {
      setIcon(this.pipControlEl, 'pip-full')
    })
    this.player.$('.vjs-tech').addEventListener('leavepictureinpicture', () => {
      setIcon(this.pipControlEl, 'pip')
    })
  }

  addButton(el) {
    const component = this.player.controlBar.addChild('button', { el })
    this.controlBarEl.insertBefore(component.el(), this.pipToggleEl)

    return component
  }
}

export default ControlBarPlugin
